import axios from 'axios';
import Base  from "../Base";

const url = {
  index: "/api/careers",
};

class Careers extends Base {

  static getComponents() {
    return {
      "careers-jobs": require("./Parts/Jobs"),
    };
  }

  static sendCv = async (formData)=>
    (await axios.post(`${url.index}/apply`, formData)).data;

}

export default Careers;
